import { Injectable } from '@angular/core';
import { format, isValid } from 'date-fns';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})

export class DateFormattingService {
	constructor() {
	}

	public formatDate(date: Date): Date {
		const dateFormat = environment.us ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
		let formattedDateString = format(date, dateFormat);

		return new Date(formattedDateString);
	}

	public formatDateString(date: Date): string {
		let formattedDate: string;
		if (!date || !isValid(date)) {
			return '';
		}

		const dateFormat = environment.us ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
		formattedDate = format(date, dateFormat);

		return formattedDate.toString();
	}

	public formatDateTimeString(dateTime: Date): string {
		let formattedDateTime: string;
		if (!dateTime || !isValid(dateTime)) {
			return '';
		}

		const dateTimeFormat = environment.us ? 'MM/dd/yyyy HH:mm' : 'dd/MM/yyyy HH:mm';
		formattedDateTime = format(dateTime, dateTimeFormat);

		return formattedDateTime.toString();
	}
}